// dependencies.
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
// components.
import AuthTemplate from '../../templates/AuthScreen'
import { Body } from '../../components/Typography'
// utils.
import notifyToast from '../../js/notifyToast'
// constants.
import { RESET_FORM } from './constants'
import { getUserByDocument } from '../../js/firebase/firebase'
import firebaseErrorMessage from '../../js/firebase/firebaseErrorTranslator'
import { sendReset } from '../../js/auth/authActions'
import { Loader } from '../../components/Icon'

/*******************************/
/*                             */
/*    Reset Password Screen    */
/*                             */
/*******************************/

// main component.
const ResetScreen = () => {
  // hooks.
  const navigate = useNavigate()
  // states.
  const [document, setDocument] = useState('')
  const [loaded, setLoaded] = useState(false)
  const [formErrors, setFormErrors] = useState({})

  // ------------------------------------------------------------------------------------------- //
  // Handle actions                                                                              //
  // ------------------------------------------------------------------------------------------- //

  // handle update value change.
  const handleValueChange = (values) => {
    setDocument(values.document)
    setFormErrors((prev) => ({
      ...prev,
      ...(values.document ? { document: '' } : {}),
      submit: '',
    }))
  }

  // navigate to sign-in page.
  const handleSigninClick = () => {
    navigate('/signin')
  }

  const handleResetPasswordClick = async (document) => {
    // check if first signin
    if (!document) {
      setFormErrors({ document: 'Debe ingresar su documento' })
      return
    }
    setFormErrors({})
    setLoaded(true)
    try {
      const userDoc = await getUserByDocument(document)
      if (!userDoc.exists) {
        setFormErrors({ submit: 'No existe un usuario con el documento ingresado' })
        return
      }
      const userData = userDoc.data()
      const defaultEmail = `${userData.document}@ccu.uy`
      if (userData.email && userData.email !== defaultEmail) {
        const response = await sendReset(userData.email)
        if (response === 'sent') {
          notifyToast(
            'Se le envió un email con instrucciones para cambiar su contraseña',
            'success'
          )
        } else {
          setFormErrors({ submit: firebaseErrorMessage(response) })
        }
      } else {
        setFormErrors({
          submit:
          'El usuario no tiene un email asociado, se le debe solicitar a un administrador que restablezca la contraseña',
        })
      }
    } catch (error) {
      setFormErrors({ submit: 'No pudimos restablecer la contraseña. Intenta nuevamente.' })
    } finally {
      setLoaded(false)
    }
  }

  // ------------------------------------------------------------------------------------------- //
  // CONTENT                                                                                     //
  // ------------------------------------------------------------------------------------------- //

  // return content.
  return (
    <AuthTemplate
      disbledSubmit={loaded}
      description="Ingrese el documento asociado al usuario.<br /> Se le enviará un correo con instrucciones para modificar su acceso."
      form={RESET_FORM}
      submitLabel="Restablecer"
      topbarIcon="caret-left"
      topbarTitle="Restablecer"
      onChange={(value) => handleValueChange(value)}
      onSubmit={() => handleResetPasswordClick(document)}
      onTopbarAction={() => handleSigninClick()}
      formErrors={formErrors}
    >
      {formErrors.submit ? (
        <Body color="alert" align="center">
          {formErrors.submit}
        </Body>
      ) : null}
      {loaded && <Loader />}
    </AuthTemplate>
  )
}

export default ResetScreen
